import React, { Component } from 'react';

//componentes
import ReporteAca2 from './reporteAca'

class Index extends Component {

    render(){
        return(
            <div>
                <ReporteAca2 />
            </div>
        );
    }

}
export default Index;